import { useTranslation } from 'react-i18next'

export function PreDrawTable({ rows = [] }) {
  const { t } = useTranslation()
  if (rows.length === 0) return null

  return (
    <section aria-labelledby="ai-plan-predraw">
      <h3 id="ai-plan-predraw" className="text-sm font-semibold text-gray-900">{t('aiPlan.review.preDraw')}</h3>
      <p className="text-xs text-gray-500 mb-2">
        {t('aiPlan.review.preDrawHint', { hours: rows[0].window_hours })}
      </p>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left text-gray-600">
              <th className="pr-4 py-1">{t('aiPlan.review.drawDay')}</th>
              <th className="py-1">{t('aiPlan.review.adjust')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.draw_weekday} className="border-t border-gray-200">
                <td className="pr-4 py-1 font-medium">{t(`aiPlan.weekdays.${row.draw_weekday}`)}</td>
                <td className="py-1 text-gray-700">
                  {row.actions.length === 0
                    ? t('aiPlan.review.noChange')
                    : row.actions
                        .map((a) =>
                          t(`aiPlan.preDrawActions.${a.action}`, {
                            day: t(`aiPlan.weekdays.${a.weekday}`),
                            type: t(`aiPlan.sessionTypes.${a.session_type}`, a.session_type),
                          })
                        )
                        .join('; ')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
